module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_11-096a9d69d4d164459ccbcabedd932c78.jpg";